import { useDispatch, useSelector } from 'react-redux';
import { setWishlistLabel } from '../actions/wishlistLabelActions';

const useWishlistLabel = () => {
  const dispatch = useDispatch();

  const wishlistRelabel = useSelector((state) => {
    return state?.wishlistLabel?.wishlistRelabel || 'Wishlist';
  });

  const updateWishlistLabel = (newLabel) => {
    dispatch(setWishlistLabel(newLabel));
  };

  return {
    wishlistRelabel,
    updateWishlistLabel,
  };
};

export default useWishlistLabel;
